var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoID)?_c('div',[_c('div',{staticClass:"wistia_embed",class:{ ['wistia_async_' + _vm.videoID]: true }},[_vm._v("   ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }